module.exports = __webpack_public_path__ + "../assets/img/21eacb0b74188f9ff7c22c39f5daa986.webp";